<template>
	<b-modal
		@ok.prevent="handleSubmit"
		ref="participant-select-modal"
		:title="`Reasignación de Peleas | ${toRemove.participant_name}`"
		ok-title="Guardar"
		cancel-title="Cancelar"
		centered
		size="lg"
		@hidden="$emit('close')"
		no-close-on-backdrop
	>
		<div class="my-1">El rival tiene un total de {{ confrontations.length }} enfrentamientos:</div>
		<b-table-simple responsive sticky-header="60vh" no-border-collapse>
			<b-thead class="sticky-header" style="white-space: nowrap">
				<!-- <b-th class="text-center">Ejemplar</b-th> -->
				<b-th class="text-center">Torneo</b-th>
				<b-th class="text-center">Etapa</b-th>
				<b-th class="text-center">Fecha</b-th>
				<b-th class="text-center">Resultado</b-th>
				<!-- <b-th class="text-center" style="z-index: 9999">Video</b-th> -->
			</b-thead>
			<b-tbody>
				<template v-if="confrontations.length > 0">
					<b-tr v-for="(confrontation, index) in confrontations" :key="index">
						<!-- <b-td class="text-center">
								<SpecimenPlate :specimen="confrontation.specimen" show_status />
							</b-td> -->
						<b-td class="text-center">
							<div>
								<ViewImage
									:specimen="{
										id: index,
										url: confrontation.torneo.url_image,
									}"
								/>
							</div>
							<span style="font-size: 10px">{{ confrontation.torneo.name }}</span>
						</b-td>
						<b-td class="text-center">
							<b-badge :style="{ background: confrontation.torneo.stage_color }">
								{{ confrontation.torneo.stage }}
							</b-badge>
						</b-td>
						<b-td class="text-center">
							<span>{{ confrontation.date | myGlobalDayShort }}</span>
						</b-td>
						<b-td class="text-center">
							<b-badge :variant="variantResult[confrontation.result]" class="text-uppercase">
								{{ confrontation.result }}
							</b-badge>
						</b-td>
						<!-- <b-td class="text-center">
								<div
									v-if="confrontation.video.status == 2"
									@click="ValidStatusVideo(confrontation)"
									class="cursor-pointer"
								>
									<b-avatar
										:src="confrontation.video.thumb"
										rounded
										size="80"
										icon="film"
										badge
										badge-variant="danger"
									>
										<template #badge>
											{{ confrontation.video.duration || "-" }}
										</template>
									</b-avatar>
								</div>
								<div v-else>
									<b-badge variant="danger">Sin video</b-badge>
								</div>
							</b-td> -->
					</b-tr>
				</template>
				<b-tr v-if="confrontations.length === 0">
					<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
		<div class="my-1">
			Se debe cambiar el participante por uno nuevo, por favor seleccione un participante de la lista.
		</div>
		<v-select
			v-model="participantId"
			label="participant_name"
			class="mx-1"
			:options="participants"
			:reduce="(opt) => opt.id"
			placeholder="Seleccionar Participante"
			:clearable="false"
			@search="debouncedGetParticipants"
		></v-select>
	</b-modal>
</template>

<script>
import participantService from "../participants.service"
import debounce from "lodash/debounce"
import tournamentService from "@/services/tournament/default.service"
import ViewImage from "@/components/commons/ViewImage.vue"
export default {
	name: "ParticipantSelect",
	props: {
		toRemove: {
			default: null,
		},
	},
	components: {
		ViewImage,
	},
	data() {
		return {
			participantId: null,
			participants: [],
			searchText: "",
			debouncedGetParticipants: null,
			confrontations: [],
			variantResult: {
				triunfo: "success",
				empate: "warning",
				derrota: "danger",
			},
		}
	},
	created() {
		this.debouncedGetParticipants = debounce(this.getParticipants, 300)
	},
	async mounted() {
		await this.getConfrontationDetails()
		this.getParticipants("a")
		this.$refs["participant-select-modal"].toggle()
	},
	methods: {
		async getConfrontationDetails() {
			this.isPreloading()
			try {
				const { data } = await tournamentService.getDsResultsByRivalDetails({
					per_page: 1000,
					page: 1,
					fighter_id: this.toRemove.id,
				})
				this.confrontations = data.data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async getParticipants(searchText = "") {
			if (this.searchText === searchText || searchText === "") return
			this.searchText = searchText
			try {
				const params = {
					status: 0,
					search: searchText,
					pageIn: 1,
					perPageIn: 25,
					type_id: 1,
				}
				const { data } = await participantService.getContactsToStatus(params)
				this.participants = data.data.filter((item) => {
					return item.id !== this.toRemove.id
				})
			} catch (error) {
				console.log(error.message)
				this.showToast("danger", "top-right", "Participantes", "AlertCircleIcon", error.message)
			}
		},
		async handleSubmit() {
			if (!this.participantId) {
				this.showToast(
					"danger",
					"top-right",
					"Reasignacion de Peleas",
					"AlertCircleIcon",
					"Seleccione un participante"
				)
				return
			}
			try {
				const params = {
					to_remove: this.toRemove.id,
					to_switch: this.participantId,
				}
				await participantService.removeSwitchParticipant(params)
				this.$emit("close")
				this.$emit("refresh")
				this.showToast(
					"success",
					"top-right",
					"Participantes",
					"CheckCircleIcon",
					"Participante cambiado correctamente"
				)
			} catch (error) {
				console.log(error.message)
			}
		},
	},
}
</script>
